import React from 'react';

const ManageRosterContext = React.createContext(null);

export default ManageRosterContext;
